import _ from "lodash";
import * as PropTypes from 'prop-types';
import React, { useContext, useState } from "react";
import promoCodesApi from "../../../../api/promoCodesApi";
import { buyNowContext } from "../BuyNow";
import PromoAmount from "./PromoAmount";

const ReferralCode = ({ disableEntry, hideDecimalIfWhole, className }) => {
  const { referralCode, referralCodeValid } = useContext(buyNowContext);

  return (
    <section>
        { referralCode && referralCodeValid &&
          <div className={`row mb-3 mx-auto ${className}`}>
              <div className="w-100" style={{ padding: 0 }}>
                <span className="sub-txt orange-text font-italic fw-bolder">
                  {`Referral code ${referralCode} applied.`}
                </span>
              </div>
          </div>
        }
    </section>
  );
};

ReferralCode.propTypes = {
  className: PropTypes.string
};

ReferralCode.defaultProps = {
  className: ""
};

export default ReferralCode;
